import React, { Component } from 'react';
import { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PERMISSION } from '../../../constants/permission';
import { checkTablePermission, checkAddPermission } from '../../../utils/route-auth';

import Table from '../../../components/CustomTable';
import ModalConfirmation from '../../../components/ModalConfirmation';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';
import moment from 'moment';

import { options, optionsHistory } from './constant';

import {
    getNewOptimizerListAction,
    getOptimizerListAction,
    getOptimizerListRecommendationAction,
    getPaymentRelatedAccessAction,
    getProfileListAllAction,
    getTenantAction
} from '../../../actions';
import Spinner from '../../../components/Spinner';
import Select from 'react-select';
import NewRecommendation from './recommendationCard';
import { isApiCallSuccess, isTenantDemoAdvertiser } from '../../../selectors';
import { optimizerListAll } from '../../../constants/demo/optimizerData';


const Card = asyncRoute(() => import('../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            advertiserListData: [],
            confirmationOpen: false,
            confirmationInfo: '',
            currentTable: 1,
            currentTableName: 'Recommendation',
            currentRecommendationData: [],
            showSpinner: true,
            optimizerAcessDetails: {},
            isSemiSuspendedOrNot: '',
            showSuspendDiv: false,
            isPlatformManager: '',
            sections: [],
            IsAgency: JSON.parse(sessionStorage.getItem('IsAgency')),
            accountList: [],
            selectedAccount: '',
        };

    }

    isDemoAdvertiser = isTenantDemoAdvertiser(this.props.tenantId);


    // async componentDidMount() {
    //     await this.optimiserNewAll();
    // }

    async componentWillMount() {

        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        const { history } = this.props;
        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }

        if (this.state.IsAgency) {
            await this.getAccountList();
        }

        // ****************optimizer Access Payment subscription realted Code starts here**********************************

        const dataLocal = JSON.parse(localStorage.getItem("PreSignInData"))
        let Isplat = dataLocal.responseList[0].tenantType
        this.setState({ isPlatformManager: Isplat == "Platform Manager" })
        if (Isplat == "Platform Manager") {
            await this.optimiserNewAll();
            await this.getTenantsList();
            // await this.historyApi();
            // await this.currentRecommendationApi();
            this.setState({ showSpinner: false })
        } else {
            await this.optimiserNewAll();
            // await this.AcessValidate();
            // await this.historyApi();
            // await this.currentRecommendationApi();
            this.setState({ showSpinner: false })
        }

        // ****************optimizer Access Payment subscription realted Code End here*********************************

    }

    // getAccountList = async () => {
    //     const { getProfileListAllAction, tenantId, authToken, userId } = this.props;
    //     const { responseCode: { status = '' }, response } = await getProfileListAllAction({ tenantId, authToken, userId });
    //     if (status == 'Success') {
    //         const accountList = response.map((data) => {
    //             return {
    //                 ...data,
    //                 label: data.advertiserName,
    //                 value: data.advertiserId
    //             }
    //         })
    //         accountList.unshift({ label: 'All', value: 'all' });
    //         this.setState({ accountList, selectedAccount: 'all' });
    //     }
    // }

    getAccountList = async () => {
        const { getProfileListAllAction, tenantId, authToken, userId } = this.props;
        const { responseCode: { status = '' }, response } = await getProfileListAllAction({ tenantId, authToken, userId });
        if (isApiCallSuccess(status)) {
            let accountList = response.map((data) => ({
                ...data,
                label: data.advertiserName,
                value: data.advertiserId
            }));
            // Add the "All" option at the beginning of the list
            accountList.unshift({ label: 'All', value: 'all' });
            const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData'));
            const defaultSelectedValue = advertiserData && Object.keys(advertiserData).length !== 0 ? advertiserData : accountList[0]; // Select the "All" item by default if advertiserData is empty
            this.setState({ accountList, selectedAccount: defaultSelectedValue });
        }
    }

    getTenantsList = async () => {
        const { tenantListAllData, getTenantAction, tenantId, authToken, userId } = this.props;
        let list = tenantListAllData;
        if (list && list.length == 0) {
            const { responseCode: { status = '' }, responseList } = await getTenantAction({ tenantId, authToken, userId });
            if (isApiCallSuccess(status) && responseList && responseList.length > 0) {
                list = responseList;
            }
        }
        if (list && list.length > 0) {
            let accountList = list.map((data) => ({
                ...data,
                label: data.tenantName,
                value: data.tenantId
            }));
            // Add the "All" option at the beginning of the list
            accountList.unshift({ label: 'All', value: 'all' });
            const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData'));
            const defaultSelectedValue = advertiserData && Object.keys(advertiserData).length !== 0 ? advertiserData : accountList[0];
            // Select the "All" item by default if advertiserData is empty
            this.setState({ accountList, selectedAccount: defaultSelectedValue });
        }
    }

    AcessValidate = async () => {
        const { tenantId, userId, authToken, getPaymentRelatedAccessAction, history } = this.props

        const { responseCode: { status }, response } = await getPaymentRelatedAccessAction({ tenantId, authToken, userId });
        let optimizerAcessDetails = {}
        let paymentAccess
        let isSemiSuspendedOrNot
        if (status.toLowerCase() == "success") {
            paymentAccess = response
            if (paymentAccess && paymentAccess.subscriptionDetails && paymentAccess.subscriptionDetails.length > 0) {

                let accessDetails = paymentAccess && paymentAccess.subscriptionDetails[0]
                isSemiSuspendedOrNot = accessDetails.atdAccessModel.status && accessDetails.atdAccessModel.status
                optimizerAcessDetails = accessDetails.atdAccessModel.accessDetailsList.find((data) => data.screenId == 2)
                // if (isSemiSuspendedOrNot == 2 || optimizerAcessDetails.type == 0) {
                //     options.actionsThead = false
                // } else {
                //     options.actionsThead = true
                // }

                // if (isSemiSuspendedOrNot == 1 || (optimizerAcessDetails && optimizerAcessDetails.type == 1) || (optimizerAcessDetails && optimizerAcessDetails.type == 2)) {
                if (isSemiSuspendedOrNot == 1) {
                    // await this.historyApi();
                    // await this.currentRecommendationApi();
                }
                this.setState({ optimizerAcessDetails, isSemiSuspendedOrNot })
            }
            else {
                history.push(`/${routes.mainRoute}/${routes.containers.errors}`)
            }
            this.setState({ showSuspendDiv: true })
        } else {
            history.push(`/${routes.mainRoute}/${routes.containers.errors}`)

        }


    }

    historyApi = async () => {
        try {
            const { tenantId, authToken, userId, getOptimizerListAction } = this.props
            const {
                responseCode: { status = "" },
                responseList,
            } = await getOptimizerListAction({ tenantId, authToken, userId });
            if (status == "Success") {
                const data = responseList[0].otherRecomendations;
                this.setState({ historyData: data });
            } else {
                this.setState({ showSpinner: false })
            }
        }
        catch (err) {
            // console.log(err);
            this.setState({ showSpinner: false })
        }



    }

    optimiserDataFormatter(responseData) {
        const sectionDescriptions = {
            generativeAI: "This section provides recommendations generated through AI algorithms.",
            blacklisting: "This section helps in blacklisting domains, age groups, gender, and more to improve targeting.",
            budgetOptimisation: "This section optimizes budget allocation and targets for better campaign performance.",
            bidControl: "This section controls bidding strategies based on demographics and audience analysis."
            // Add more descriptions as needed
        };

        const keyMapping = {
            targetcpm: "Target CPM",
            targetcpc: "Target CPC",
            targetcpa: "Target CPA",
            budgetAllocation: "Budget Allocation",
        };


        return Object.keys(responseData).map(sectionKey => {
            const sectionData = responseData[sectionKey];
            let title = sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1); // Capitalize first letter
            if (sectionKey === "blacklisting") {
                title = "Blacklisting-Whitelisting";
            }
            return {
                id: sectionData.id,
                title: title,
                description: sectionDescriptions[sectionKey] || "Description not available",
                totalCampaigns: sectionData.totalCampaign,
                subsections: sectionData.type.map(subsection => ({
                    id: subsection.id,
                    title: keyMapping[subsection.key] || (subsection.key.charAt(0).toUpperCase() + subsection.key.slice(1)),
                    value: subsection.value
                }))
            };
        });
    }


    // Function to handle API call and update sections
    optimiserNewAll = async () => {
        try {
            const { tenantId, authToken, userId, getNewOptimizerListAction } = this.props;
            const { selectedAccount } = this.state;

            if (this.isDemoAdvertiser) {
                const sections = this.optimiserDataFormatter(optimizerListAll.responseList);
                this.setState({ sections, showSpinner: false });
                return;
            }


            let params = {
                list: 'all'
            };
            if (selectedAccount.advertiserId || selectedAccount.tenantId) {
                params.advId = selectedAccount.advertiserId ? selectedAccount.advertiserId : selectedAccount.tenantId;
                sessionStorage.setItem('advertiserData', JSON.stringify(selectedAccount));
            }

            const { responseCode: { status = "" }, responseList } = await getNewOptimizerListAction({ tenantId, authToken, userId, params });

            if (isApiCallSuccess(status)) {
                let responseData = responseList;
                const sections = this.optimiserDataFormatter(responseData);

                this.setState({ sections, showSpinner: false });
            } else {
                this.setState({ showSpinner: false });
            }
        } catch (err) {
            console.error(err);
            this.setState({ showSpinner: false });
        }
    }


    removeDuplicateObjects = (data, key) => {
        const uniqueData = data.reduce((acc, obj) => {
            if (!acc.find((item) => item[key] === obj[key])) {
                acc.push(obj);
            }
            return acc;
        }, []);
        return uniqueData;
    };


    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };


    confirmationCallBack = (success, info) => {
        this.setState({ confirmationOpen: false });
    };


    handleRecommedationAction = (row, action) => {
        const { match, history } = this.props;
        if (action.type === 'view') {
            this.handleView(row, match, history);
        }
    };


    handleView(row, match, history) {
        history.push(`${match.path}/${routes.optimizer.recommendations}/${row.advertiserId}`)
    }

    handleViewHistory = () => {
        const { match, history } = this.props;
        history.push(`${match.path}/${routes.optimizer.history}`)
    }

    handleTotalSectionClick = (section) => {
        const { match, history } = this.props;
        const subType = section.subsections.map(subsection => subsection.id);
        const optimizerTypes = { type: section.id, subType: subType };

        const title = section.title.toLowerCase()
        history.push(`${match.path}/${title}`, optimizerTypes)
    }

    handleSubsectionClick = (section, subsection) => {
        const { match, history } = this.props;
        const optimizerTypes = { type: section.id, subType: [subsection.id], variation: 'subType' };

        const title = section.title.toLowerCase();
        const subtitle = subsection.title.toLowerCase();
        history.push(`${match.path}/${title}/${subtitle}`, optimizerTypes)
    }

    handleSelectChange = (selectedOptions, formKey) => {
        if (formKey == "account") {
            this.setState({ selectedAccount: selectedOptions }, () => {
                sessionStorage.setItem('advertiserData', JSON.stringify({}));
                // console.log("selectedAccount", this.state.selectedAccount);
                this.optimiserNewAll();
            })
        }
    };

    render() {

        // const sections = [
        //     {
        //         title: "Generative",
        //         description: "This section provides recommendations generated through AI algorithms.",
        //         totalCampaigns: 10,
        //         subsections: [
        //             { title: "Keywords", value: 5 },
        //             { title: "Creatives", value: 7 }
        //         ]
        //     },
        //     {
        //         title: "Blacklisting",
        //         description: "This section helps in blacklisting domains, age groups, gender, and more to improve targeting.",
        //         totalCampaigns: 10,
        //         subsections: [
        //             { title: "Creatives", value: 5 },
        //             { title: "Domain", value: 7 },
        //             { title: "Age", value: 2 },
        //             { title: "Gender", value: 1 },
        //             { title: "Geo", value: 3 },
        //             { title: "Placement", value: 1 },
        //             { title: "Devices", value: 1 }
        //         ]
        //     },
        //     {
        //         title: "Optimiser",
        //         description: "This section optimizes budget allocation and targets for better campaign performance.",
        //         totalCampaigns: 10,
        //         subsections: [
        //             { title: "Budget Allocation", value: 5 },
        //             { title: "Target CPM", value: 7 },
        //             { title: "Target CPC", value: 5 },
        //             { title: "Target CPA", value: 2 }
        //         ]
        //     },
        //     {
        //         title: "Bid-Control",
        //         description: "This section controls bidding strategies based on demographics and audience analysis.",
        //         totalCampaigns: 10,
        //         subsections: [
        //             { title: "Age", value: 5 },
        //             { title: "Gender", value: 7 },
        //             { title: "Audience", value: 2 },
        //             { title: "Geo", value: 1 },
        //             { title: "Campaigns", value: 1 }
        //         ]
        //     },
        //     // Add more sections as needed
        // ];


        // console.log("tableIoData", tableIoData);
        const { match, ioListAll, configurationList } = this.props;
        const { selectedAccount, accountList, IsAgency, sections, currentSection, currentSubsection, totalCampaigns, tables, showTable, viewHistory, confirmationOpen, confirmationInfo, optionsList, currentTable, currentTableName, historyData, currentRecommendationData, showSpinner, optimizerAcessDetails = {}, isSemiSuspendedOrNot, showSuspendDiv, isPlatformManager } = this.state;
        const advertiserData = JSON.parse(sessionStorage.getItem('advertiserData'));


        return (
            <>
                {showSpinner && <Spinner />}
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}
                <div className="main-panel ion">
                    <div className="content-wrapper">
                        {/* <BreadCrumb /> */}


                        {<div className="row mx-1">
                            {/* Header section */}
                            <div className='d-flex justify-content-between align-items-center'>
                                <h4 style={{ fontWeight: 500 }}>All Optimiser</h4>
                                {IsAgency || isPlatformManager ?
                                    <div className="d-flex col-md-5 col-sm-4 col-xs-4 align-items-center justify-content-end">
                                        <label className="mb-0 mr-2" htmlFor="tenantName">
                                            Choose Account
                                        </label>
                                        <div style={{ width: '300px' }}>
                                            <Select
                                                options={accountList}
                                                isMulti={false}
                                                placeholder="Select Account"
                                                defaultValue={selectedAccount}
                                                value={selectedAccount}
                                                onChange={(selected) => this.handleSelectChange(selected, "account")}
                                                className="campaignFilter my-2"
                                            />
                                        </div>
                                        <div className="mx-2" style={{ color: "#C4CCD8" }}> {"  |  "} </div>

                                        {/* Button to view history */}
                                        <div style={{ color: "#303890", cursor: "pointer" }} className='' onClick={this.handleViewHistory}>
                                            <i className='ti ti-file-search'></i>
                                            View History
                                        </div>
                                    </div>
                                    :
                                    <div className="d-flex col-md-5 col-sm-4 col-xs-4 align-items-center justify-content-end">
                                        <div style={{ color: "#303890", cursor: "pointer" }} className='' onClick={this.handleViewHistory}>
                                            <i className='ti ti-file-search'></i>
                                            View History
                                        </div>
                                    </div>
                                }

                            </div>

                            {/* Render optimizer sections */}
                            {sections && sections.length > 0 ? sections.map((section, index) => (
                                <NewRecommendation
                                    key={index}
                                    section={section || []}
                                    handleTotalSectionClick={this.handleTotalSectionClick}
                                    handleSubsectionClick={this.handleSubsectionClick}
                                />
                            ))
                                :
                                <Card>
                                    <div className='text-center'>
                                        <h5>No Data Available</h5>
                                    </div>
                                </Card>
                            }
                        </div>
                        }
                    </div>
                </div >
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        paymentAccess: get(state, 'app.paymentAccess.response', {}),
        getUserPermissionList: get(state, 'app.getUserPermissionList', []),
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioListAll: get(state, 'app.ioListAllReport.responseList', []),
        tenantListAllData: get(state, 'app.tenantListAll.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getOptimizerListAction,
        getOptimizerListRecommendationAction,
        getPaymentRelatedAccessAction,
        getNewOptimizerListAction,
        getProfileListAllAction,
        getTenantAction
    }
)(index));

// ----*  IO propTypes * ----
index.propTypes = {
    configurationList: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
};